import React from 'react';
import { Text } from '@perch-labs/shrike';
import { Container } from 'styles';
import { copyFor } from 'config';
import { Numeral } from 'pages/billing/components/billing-explainer/billing-explainer.style';

const getCopy = copyFor('billing.billingExplainer.arcadiaConsolidatedBilling');

export const ArcadiaConsolidatedBilling = () => {
  const steps = getCopy('steps');
  return (
    <>
      {steps.map((text, index) => (
        <Container
          flex
          direction="row"
          margin={{ top: index === 0 ? '16px' : '24px' }}
          key={text}
        >
          <Numeral>
            <Text textStyle="heading400">{index + 1}</Text>
          </Numeral>
          <Text margin={{ left: '16px', top: '0', bottom: '0' }}>{text}</Text>
        </Container>
      ))}
    </>
  );
};
